import { makeAutoObservable } from 'mobx'
// import { RootStore } from 'mobx-stores/root-store'
import { NamedImageDTO, StoreDTO, UserDTO } from 'models'
import { Api, FetchOptions } from 'services'

export class StoresMainStore {
  private storeApi: Api['storeApi']
  private rootStore: any

  constructor (rootStore: any) {
    this.storeApi = rootStore.generalStore.api.storeApi
    this.rootStore = rootStore
    makeAutoObservable(this)
  }

  // OBSERVABLES
  private stores: Map<number, StoreDTO> = new Map()
  private usersStores: Map<string, NamedImageDTO[]> = new Map()
  // ACTIONS
  private setStore = (store: StoreDTO): void => {
    this.stores.set(store.id, store)
  }

  private setStores = (stores: Map<number, StoreDTO>): void => {
    this.stores = stores
  }

  private setUsersStores = (
    usersStores: Map<string, NamedImageDTO[]>
  ): void => {
    this.usersStores = usersStores
  }

  // METHODS
  public clearStore = (): void => {
    this.setStores(new Map())
    this.setUsersStores(new Map())
  }

  public assignUserToStore = async (
    storeId: number | string,
    userDto: UserDTO,
    options?: FetchOptions
  ): Promise<StoreDTO> => {
    return await this.storeApi.assignUser(storeId, userDto, options)
  }

  public getStoreById = async (storeId: number | string): Promise<StoreDTO> => {
    let storeIdAsNumber = null
    try {
      storeIdAsNumber = Number(storeId)
      if (isNaN(storeIdAsNumber)) {
        const errorMessage = `Not a valid number ${storeIdAsNumber}`
        storeIdAsNumber = null
        throw new Error(errorMessage)
      }
    } catch (error) {
      console.error(error)
      this.rootStore.generalStore.showError(
        `Store ID ${storeId} is not a valid number`
      )
    }
    if (!storeIdAsNumber) return

    const store = await this.storeApi.getStoreById(storeId)
    if (!store) return
    this.setStore(store)

    const loadedStore = this.stores.get(storeIdAsNumber)
    if (loadedStore) return loadedStore

    return store
  }

  public loadStores = async (options?: FetchOptions): Promise<void> => {
    const storesList = await this.storeApi.getStores(options)
    if (!storesList) return
    const storeMap: Map<number, StoreDTO> = new Map(
      storesList.map(store => [store.id, store])
    )
    this.setStores(storeMap)
  }

  public loadUsersStores = async (options?: FetchOptions): Promise<void> => {
    const usersStoresData = await this.storeApi.getUsersStores(options)
    if (!usersStoresData) return
    const usersStores: Map<string, NamedImageDTO[]> = new Map(
      Object.entries(usersStoresData)
    )
    this.setUsersStores(usersStores)
  }

  public getStoresListByUserEmail = (email: string): NamedImageDTO[] => {
    return this.usersStores.get(email) || []
  }

  // COMPUTED
  public get storesList (): StoreDTO[] {
    return Array.from(this.stores.values())
  }
}
